import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import "./index.css"; // Optional if you have global styles
<link href='https://fonts.googleapis.com/css?family=Open Sans' rel='stylesheet'></link>

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);
